import { render } from "./daanPage.vue?vue&type=template&id=16177b71&scoped=true"
import script from "./daanPage.vue?vue&type=script&lang=js"
export * from "./daanPage.vue?vue&type=script&lang=js"

import "./daanPage.vue?vue&type=style&index=0&id=16177b71&lang=scss&scoped=true"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mguoxueweb_online/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16177b71"]])

export default __exports__